import { EmailNotificationPreference } from '../../models/email-notification.model';

export class LoadEmailNotificationPreference {
  static readonly type =
    '[EmailNotifications] Load Email Notification Preference Details';
}

export class LoadEmailNotificationPreferenceSuccess {
  static readonly type =
    '[EmailNotifications] Load Email Notification Preference Success';

  constructor(public notifications: EmailNotificationPreference[]) {}
}

export class UpdateEmailNotificationSuccess {
  static readonly type =
    '[EmailNotifications] Update Email Notification Preference Success';

  constructor(public notifications: EmailNotificationPreference[]) {}
}
export class UpdateEmailNotification {
  static readonly type =
    '[EmailNotifications] Update Email Notification Success';

  constructor(public notifications: EmailNotificationPreference[]) {}
}

export class LoadEmailNotificationError {
  static readonly type = '[EmailNotification] Load Email Notification Error';

  constructor(public error: string) {}
}

export class UpdateEmailNotificationError {
  static readonly type = '[EmailNotification] Update Email Notification Error';

  constructor(public error: string) {}
}
export class ResetEmailNotificationState {
  static readonly type = '[EmailNotifications] Reset Email Notification State';
}
